module.exports = __webpack_public_path__ + "static/2-2e776626843ec33821f2c3973c2dbe02.jpg";